<template>
  <div>
    <v-row class="pt-2 pl-3 pr-3">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="searchFilterData('tab'), page=1"
      >
        <!-- <v-container> -->
          <v-row>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }" >
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0 ma-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols="5" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ totalAll }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ทั้งหมด</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FEF5E9' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#E9A016'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#E9A016' : '#FEF5E9' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-clock-time-four-outline</v-icon>
                  </v-col>
                  <v-col cols="5" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{ totalPending }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">รออนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#ECF8EA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#58A144'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#58A144' : '#ECF8EA' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-check-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #58A144;">{{ totalApproved }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">อนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FBE5E4' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="7">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#D1392B'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#D1392B' : '#FBE5E4' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="5" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #D1392B;">{{ totalRejected }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ไม่อนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F5F5F5' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="5">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#757575'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#757575' : '#F5F5F5' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="7" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #757575;">{{ totalCancel }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ยกเลิก</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        <!-- </v-container> -->
      </v-item-group>
  </v-row>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ค้นหา</span>
      <v-autocomplete
        v-model="keywordBusinessName"
        :items="itemUserName"
        item-text="name"
        item-value="_id"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาจากชื่อธุรกิจ"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(''), page=1"
        @click:clear="keywordBusinessName='', searchFilterData(''), page=1"
      >
      <template v-slot:append>
        <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(''), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="button-color-outline"
            style="width: 96px; height: 38px;"
            text
            outlined
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-5">
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">สถานะ</span>
              <v-autocomplete
                v-model="statusType"
                :items="itemStatus"
                item-text="name"
                item-value="nameEn"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @click:clear="statusType='', searchFilterData(''), page=1"
              >
              </v-autocomplete>
            </v-col>
             <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">ประเภทการลงทะเบียน</span>
              <v-autocomplete
                v-model="registerType"
                :items="itemRegister"
                item-text="name"
                item-value="nameEn"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @click:clear="registerType='', searchFilterData(''), page=1"
              >
              </v-autocomplete>
            </v-col>
            <!-- วันที่สร้างแบบเก่า -->
            <v-col cols="12" class="pt-0 pb-0">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="datesCreateAt"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span class="head-search-text">วันที่สร้าง</span>
                  <v-text-field
                    class="mt-2"
                    :value="dateRangeTextCreate"
                    placeholder="ปปปป-ดด-วว ~ ปปปป-ดด-วว"
                    readonly
                    append-icon="fa-calendar-alt"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="resetCreateDate()"
                  >
                  <template v-slot:append>
                    <v-icon class="icon-eye-color">mdi-calendar</v-icon>
                  </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="datesCreateAt" :max="toDay" range color="#2BA197">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    class="button-color-outline"
                    @click="menu1 = false"
                  >
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    v-if="datesCreateAt[0] !== undefined && datesCreateAt[1] !== undefined"
                    text
                    @click="$refs.menu1.save(datesCreateAt)"
                  >
                    ตกลง
                  </v-btn>
                  <v-btn
                    v-else
                    text
                    class="button-color-outline"
                    color="gray"
                    disabled
                  >
                    ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <!-- วันที่สร้างแบบใหม่ -->
            <!-- <v-col cols="12" class="pt-0 pb-4">
              <span class="head-search-text">วันที่สร้าง</span>
                <div
                  id="covid-case-date"
                  class="d-flex mt-2"
                  style="width: 100%; border: 1px solid gray; border-radius: 4px"
                >
                  <date-range-picker
                    v-model="datesCreateAt"
                    :locale-data="local_datacreate"
                    :ranges="ranges_datacreate"
                    :autoApply="false"
                    :max-date="toDay"
                    opens="right"
                    @start-selection="logEventCreate()"
                    @toggle="CreatelogEvent_t()"
                    @update="logEventCreate('event: open', $event)"
                  >
                    <template v-slot:input="datesCreateAt">
                      <div
                        class="mt-1"
                        style="font-size: 14px;color:#999999"
                        v-if="datesCreateAt.startDate === null"
                      >
                        {{ createsetup_separator }}
                      </div>
                      <div class="mt-1" style="font-size: 14px" v-else>
                        {{ DateCreateformat_filter(datesCreateAt.startDate) }}
                        {{ createsetup_separator }}
                        {{ DateCreateformat_filter(datesCreateAt.endDate) }}
                      </div>
                    </template>
                  </date-range-picker>
                  <v-btn
                    class="mt-1"
                    small
                    icon
                    v-if="datesCreateAt.startDate != null"
                    @click="resetCreateDate()"
                  >
                    <v-icon> mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    class="mt-1"
                    small
                    icon
                    v-else
                    style="cursor: text;"
                  >
                    <v-icon class="icon-eye-color">mdi-calendar</v-icon>
                  </v-btn>
                </div>
            </v-col> -->
            <!-- วันที่แก้ไขแบบเก่า -->
            <v-col cols="12" class="pt-0 pb-0">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="datesUpdateAt"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span class="head-search-text">วันที่แก้ไขล่าสุด</span>
                  <v-text-field
                    :value="dateRangeTextUpdate"
                    placeholder="ปปปป-ดด-วว ~ ปปปป-ดด-วว"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    append-icon="fa-calendar-alt"
                    class="mt-2"
                    outlined
                    dense
                    clearable
                    @click:clear="resetUpdateDate()"
                  >
                  <template v-slot:append>
                    <v-icon class="icon-eye-color">mdi-calendar</v-icon>
                  </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="datesUpdateAt" :max="toDay" range color="#2BA197">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    class="button-color-outline"
                    @click="menu2 = false"
                  >
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    v-if="datesUpdateAt[0] !== undefined && datesUpdateAt[1] !== undefined"
                    text
                    class="button-color-outline"
                    @click="$refs.menu2.save(datesUpdateAt)"
                  >
                    ตกลง
                  </v-btn>
                  <v-btn
                    v-else
                    text
                    color="gray"
                    disabled
                  >
                    ตกลง
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <!-- วันที่แก้ไขแบบใหม่ -->
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">วันที่แก้ไขล่าสุด</span>
                <div
                  id="covid-case-date"
                  class="d-flex mt-2"
                  style="width: 100%; border: 1px solid gray; border-radius: 4px; z-index: 9999;"
                >
                  <date-range-picker
                    v-model="datesUpdateAt"
                    :locale-data="local_dataupdate"
                    :ranges="ranges_dataupdate"
                    :autoApply="false"
                    :max-date="toDay"
                    opens="right"
                    @start-selection="logEventUpdate()"
                    @toggle="UpdatelogEvent_t()"
                    @update="logEventUpdate('event: open', $event)"
                  >
                    <template v-slot:input="datesUpdateAt">
                      <div
                        class="mt-1"
                        style="font-size: 14px;color:#999999"
                        v-if="datesUpdateAt.startDate === null"
                      >
                        {{ updatesetup_separator }}
                      </div>
                      <div class="mt-1" style="font-size: 14px" v-else>
                        {{ DateUpdateformat_filter(datesUpdateAt.startDate) }}
                        {{ updatesetup_separator }}
                        {{ DateUpdateformat_filter(datesUpdateAt.endDate) }}
                      </div>
                    </template>
                  </date-range-picker>
                  <v-btn
                    class="mt-1"
                    small
                    icon
                    v-if="datesUpdateAt.startDate != null"
                    @click="resetUpdateDate()"
                  >
                    <v-icon> mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    class="mt-1"
                    small
                    icon
                    v-else
                    style="cursor: text;"
                  >
                    <v-icon class="icon-eye-color">mdi-calendar</v-icon>
                  </v-btn>
                </div>
            </v-col> -->
          </v-row>
          <v-row class="pa-3">
            <v-btn
              class="button-color-outline mr-4"
              outlined
              style="width: 135px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color"
              style="width: 135px;"
              dark
              @click="searchFilterData('filter')"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  // getSelectApproveRequestCompany,
  // getAllSelectBusiness,
  getAllCountApproved,
  getAllRegisterType,
  getAllStatus
} from '@/API/API'
// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// const moment = require('moment')
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  components: {
    // DateRangePicker
  },
  data () {
    return {
      // ตัวแปรที่นำมาใช้
      // วันที่สร้าง
      // datesCreateAt: {
      //   startDate: null,
      //   endDate: null
      // },
      // // วันที่แก้ไข
      // datesUpdateAt: {
      //   startDate: null,
      //   endDate: null
      // },
      // local_datacreate: {
      //   format: 'yyyy-mm-dd',
      //   direction: 'ltr',
      //   applyLabel: 'ตกลง',
      //   cancelLabel: 'ยกเลิก'
      // },
      // local_dataupdate: {
      //   format: 'yyyy-mm-dd',
      //   direction: 'ltr',
      //   applyLabel: 'ตกลง',
      //   cancelLabel: 'ยกเลิก'
      // },
      // ranges_datacreate: {
      //   วันนี้: [new Date(), new Date()],
      //   สัปดาห์นี้: [
      //     new Date(new Date().setDate(new Date().getDate() - 1)),
      //     new Date(new Date().setDate(new Date().getDate() - 1))
      //   ],
      //   เดือนนี้: [
      //     new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      //     new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      //   ],
      //   // 'This year': [
      //   //   new Date(new Date().getFullYear(), 0, 1),
      //   //   new Date(new Date().getFullYear(), 11, 31)
      //   // ],
      //   เดือนที่ผ่านมา: [
      //     new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      //     new Date(new Date().getFullYear(), new Date().getMonth(), 0)
      //   ]
      // },
      // ranges_dataupdate: {
      //   วันนี้: [new Date(), new Date()],
      //   สัปดาห์นี้: [
      //     new Date(new Date().setDate(new Date().getDate() - 1)),
      //     new Date(new Date().setDate(new Date().getDate() - 1))
      //   ],
      //   เดือนนี้: [
      //     new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      //     new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      //   ],
      //   // 'This year': [
      //   //   new Date(new Date().getFullYear(), 0, 1),
      //   //   new Date(new Date().getFullYear(), 11, 31)
      //   // ],
      //   เดือนที่ผ่านมา: [
      //     new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      //     new Date(new Date().getFullYear(), new Date().getMonth(), 0)
      //   ]
      // },
      // createsetup_separator: 'ปปปป/ดด/วว - ปปปป/ดด/วว',
      // updatesetup_separator: 'ปปปป/ดด/วว - ปปปป/ดด/วว',
      // end
      toDay: new Date().toISOString(),
      tapData: ['', 'pending', 'approved', 'denied', 'cancel'],
      tapSelect: 0,
      keywordBusinessName: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      itemUserName: [],
      itemPosition: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemRequestType: [],
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 15,
        page: 1
      },
      menu: false,
      menu1: false,
      datesUpdateAt: [],
      datesCreateAt: [],
      menu2: false,
      createAt: '',
      updateAt: '',
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      totalCancel: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      approveRole: localStorage.approveRole,
      itemStatus: [],
      statusType: '',
      itemRegister: [],
      registerType: ''
    }
  },
  watch: {
    // แบบเก่า
    datesUpdateAt: function (val) {
      var dataupdateAt = {
        start: '',
        end: ''
      }
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        if (Date.parse(this.datesUpdateAt[0]) < Date.parse(this.datesUpdateAt[1])) {
          dataupdateAt = {
            start: this.datesUpdateAt[0],
            end: this.datesUpdateAt[1]
          }
        } else {
          dataupdateAt = {
            start: this.datesUpdateAt[1],
            end: this.datesUpdateAt[0]
          }
        }
        this.updateAt = dataupdateAt
        // this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
      }
    },
    datesCreateAt: function (val) {
      var datacreateAt = {
        start: '',
        end: ''
      }
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        if (Date.parse(this.datesCreateAt[0]) < Date.parse(this.datesCreateAt[1])) {
          datacreateAt = {
            start: this.datesCreateAt[0],
            end: this.datesCreateAt[1]
          }
        } else {
          datacreateAt = {
            start: this.datesCreateAt[1],
            end: this.datesCreateAt[0]
          }
        }
        this.createAt = datacreateAt
      }
    }
    // แบบใหม่
    // datesUpdateAt: function (val) {
    //   var dataupdateAt = {
    //     start: '',
    //     end: ''
    //   }
    //   if (
    //     this.datesUpdateAt.startDate != null &&
    //     this.datesUpdateAt.endDate != null
    //   ) {
    //     dataupdateAt = {
    //       start: this.datesUpdateAt.startDate
    //         ? moment(this.datesUpdateAt.startDate).format('YYYY-MM-DD')
    //         : '',
    //       end: this.datesUpdateAt.endDate
    //         ? moment(this.datesUpdateAt.endDate).format('YYYY-MM-DD')
    //         : ''
    //     }
    //     this.updateAt = dataupdateAt
    //     console.log(this.updateAt)
    //   } else {
    //     this.updateAt = ''
    //   }
    // },
    // datesCreateAt: function (val) {
    //   var datacreateAt = {
    //     start: '',
    //     end: ''
    //   }
    //   if (
    //     this.datesCreateAt.startDate != null &&
    //     this.datesCreateAt.endDate != null
    //   ) {
    //     datacreateAt = {
    //       start: this.datesCreateAt.startDate
    //         ? moment(this.datesCreateAt.startDate).format('YYYY-MM-DD')
    //         : '',
    //       end: this.datesCreateAt.endDate
    //         ? moment(this.datesCreateAt.endDate).format('YYYY-MM-DD')
    //         : ''
    //     }
    //     this.createAt = datacreateAt
    //     console.log(this.createAt)
    //   } else {
    //     this.createAt = ''
    //   }
    // }
  },
  computed: {
    dateRangeTextUpdate () {
      const chkDate = ''
      if (this.datesUpdateAt.length !== 0) {
        if (Date.parse(this.datesUpdateAt[0]) < Date.parse(this.datesUpdateAt[1])) {
          return this.datesUpdateAt[0] + ' ~ ' + this.datesUpdateAt[1]
        } else {
          return this.datesUpdateAt[1] + ' ~ ' + this.datesUpdateAt[0]
        }
      } else {
        return chkDate
      }
    },
    dateRangeTextCreate () {
      const chkDate = ''
      if (this.datesCreateAt.length !== 0) {
        if (Date.parse(this.datesCreateAt[0]) < Date.parse(this.datesCreateAt[1])) {
          return this.datesCreateAt[0] + ' ~ ' + this.datesCreateAt[1]
        } else {
          return this.datesCreateAt[1] + ' ~ ' + this.datesCreateAt[0]
        }
      } else {
        return chkDate
      }
    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    await this.getSelectData()
    await this.getSelectStatus()
    await this.getSelectRegister()
    // await this.searchFilterData() // ปิดเทส 11/04
    await this.updateTotal()
  },
  mounted () {
    // EventBus.$on('setApproveRole', this.setApproveRole) // ปิดเทส 11/04
  },
  beforeDestroy () {
    EventBus.$off('manageCompanySearch')
    // EventBus.$off('setApproveRole') // ปิดเทส 11/04
  },
  methods: {
    // ฟังก์ชันวันที่ถ้าไม่เข้าใจให้ console.log ดูข้อมูลก่อน
    // logEventCreate () {
    //   this.createsetup_separator = '-'
    // },
    // logEventUpdate () {
    //   this.updatesetup_separator = '-'
    // },
    // CreatelogEvent_t () {
    //   if (this.datesCreateAt.endDate == null) {
    //     this.createsetup_separator = 'ปปปป/ดด/วว - ปปปป/ดด/วว'
    //   }
    // },
    // UpdatelogEvent_t () {
    //   if (this.datesUpdateAt.endDate == null) {
    //     this.updatesetup_separator = 'ปปปป/ดด/วว - ปปปป/ดด/วว'
    //   }
    // },
    // DateCreateformat_filter (date) {
    //   if (this.datesCreateAt.startDate != null) {
    //     this.createsetup_separator = '-'
    //   } else {
    //     this.createsetup_separator = '-'
    //   }
    //   if (date) {
    //     return moment(date).format('YYYY-MM-DD')
    //   } else {
    //     return ''
    //   }
    // },
    // DateUpdateformat_filter (date) {
    //   if (this.datesUpdateAt.startDate != null) {
    //     this.updatesetup_separator = '-'
    //   } else {
    //     this.updatesetup_separator = '-'
    //   }
    //   if (date) {
    //     return moment(date).format('YYYY-MM-DD')
    //   } else {
    //     return ''
    //   }
    // },
    // end
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      // await this.getSelectData()
      await this.searchFilterData()
    },
    async updateTotal () {
      var data = {
        businessModelType: 'all',
        requestType: 'create'
      }
      try {
        const res = await getAllCountApproved(data, this.$store.state.token)
        if (res.success) {
          this.totalAll = res.counter[0].all
          this.totalPending = res.counter[0].pending
          this.totalApproved = res.counter[0].approved
          this.totalRejected = res.counter[0].denied
          this.totalCancel = res.counter[0].cancel
        }
      } catch (error) {
        console.log(error)
      }
    },
    // getSelectValue (filter) {
    //   // this.itemUserName = filter.result.companyNameList
    //   this.itemBusiness = filter.result.businessTypeList
    // },
    // เก่า
    // async getSelectData () {
    //   try {
    //     const res = await getSelectApproveRequestCompany(this.$store.state.token)
    //     if (res.success) {
    //       if (res.result) {
    //         this.itemCompanyName = res.result
    //         this.itemGroupCompanyName = res.result.groupCompanyList
    //         this.itemPosition = res.result.positionList
    //         this.itemRequestType = res.result.requestTypeList
    //         this.itemUserName = res.result
    //       }
    //     }
    //   } catch (error) {
    //   } finally {
    //   }
    // },
    // รายชื่อบริษัท ใหม่
    async getSelectData () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/selector/organization?businessModelType=`,
        headers: {
          authorization: this.tokenUser
        }
      }).then(response => {
        this.itemUserName = response.data.selector
      }).catch(e => {
        console.log(e)
      })
      // try {
      //   const res = await getAllSelectBusiness(this.$store.state.token)
      //   if (res.success) {
      //     this.itemUserName = res.selector
      //   }
      // } catch (error) {
      //   console.log(error)
      // } finally {
      // }
    },
    // รายชื่อประเภทสถานะ
    async getSelectStatus () {
      try {
        const res = await getAllStatus(this.$store.state.token)
        if (res.success) {
          this.itemStatus = res.selector
        }
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    // รายชื่อประเภทการลงทะเบียน
    async getSelectRegister () {
      try {
        const res = await getAllRegisterType(this.$store.state.token)
        if (res.success) {
          this.itemRegister = res.selector
        }
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    resetUpdateDate () {
      this.updateAt = ''
      this.datesUpdateAt = []
      // this.datesUpdateAt.startDate = null
      // this.datesUpdateAt.endDate = null
      // this.updatesetup_separator = 'ปปปป/ดด/วว - ปปปป/ดด/วว'
      this.searchFilterData(1, 15)
    },
    resetCreateDate () {
      this.createAt = ''
      this.datesCreateAt = []
      // this.datesCreateAt.startDate = null
      // this.datesCreateAt.endDate = null
      // this.createsetup_separator = 'ปปปป/ดด/วว - ปปปป/ดด/วว'
      this.searchFilterData(1, 15)
    },
    resetFilterData () {
      this.statusType = ''
      this.registerType = ''
      this.keywordBusinessName = ''
      this.keywordRequestNo = ''
      this.keywordPosition = []
      this.keywordType = []
      this.keywordCompanyName = []
      this.keywordGroupCompanyName = []
      this.createAt = ''
      this.updateAt = ''
      this.datesUpdateAt = []
      this.datesCreateAt = []
      // this.datesCreateAt.startDate = null
      // this.datesCreateAt.endDate = null
      // this.createsetup_separator = 'ปปปป/ดด/วว - ปปปป/ดด/วว'
      // this.datesUpdateAt.startDate = null
      // this.datesUpdateAt.endDate = null
      // this.updatesetup_separator = 'ปปปป/ดด/วว - ปปปป/ดด/วว'
      this.filterData = {
        statusType: '',
        registerType: '',
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode
      }
      // this.searchFilterData(1, 15)
      EventBus.$emit('manageCompanySearch', this.filterData)
    },
    searchFilterData (name) {
      var statusnew = ''
      if (name === 'filter') {
        statusnew = [this.statusType]
      } else {
        statusnew = this.setObjFilter(this.tapData[this.tapSelect])
      }

      this.filterData = {
        businessModelTap: '',
        // businessType: this.businessType,
        registerType: this.registerType,
        searchNameAndEmpId: this.keywordBusinessName,
        // reqCompanyNo: this.keywordRequestNo,
        requestType: this.setObjFilter(this.keywordType),
        // companyName: this.setObjFilter(this.keywordCompanyName),
        // status: this.setObjFilter(this.tapData[this.tapSelect]), //เก่า
        status: statusnew,
        createAt: this.createAt,
        updateAt: this.updateAt,
        role: this.approveRole
      }
      // console.log('filter', this.filterData)
      EventBus.$emit('manageCompanySearch', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
<style lang="scss">
// ------------Css date Range picker ----------------------//
#covid-case-date {
  .daterangepicker td.active {
    // background-color: deeppink !important;
    background-color: #2ba197 !important;
    border-color: transparent;
    color: #fff;
  }

  .daterangepicker td.in-range {
    // background-color: rgb(255, 206, 232);
    background: #f3f5fa;
  }

  div.calendars {
    display: block !important;
  }

  .vue-daterange-picker[data-v-1ebd09d2] {
    position: relative;
    display: inline-block;
    min-width: 85% !important;
  }

  .reportrange-text[data-v-1ebd09d2] {
    background: #fff;
    cursor: pointer;
    padding: 5px 10px;
    border: none;
    width: 100% !important;
    height: 40px;
    overflow: hidden;
    border-radius: 5px;
  }

  .daterangepicker .ranges ul {
    justify-content: center;
    list-style: none;
    margin: auto;
    padding: 0;
    display: flex;
    width: 100%;
    min-width: 0px !important;
  }

  .daterangepicker.openscenter[data-v-1ebd09d2] {
    right: auto;
    margin-left: 30px !important;
    -webkit-transform: translate(-50%) !important;
    transform: translate(-50%);
    min-width: 0px !important;
  }
  .daterangepicker.show-ranges .drp-calendar.left {
    border-left: 0px solid #ffffff;
  }
  .daterangepicker .calendars-container {
    justify-content: space-evenly;
  }
  .daterangepicker .ranges li {
    font-size: 14px !important;
    padding: 8px 12px;
    cursor: pointer;
  }
  // ปุ่ม cancel/apply
  .daterangepicker .drp-buttons .btn {
    margin-left: 8px;
    font-size: 14px;
    font-weight: 400;
    padding: 8px 16px;
  }
  .daterangepicker .btn-secondary {
    background-color: #fff;
    color: #2ba197;
    border-radius: 6px;
    border: 1px solid;
  }
  .daterangepicker .btn-success {
    background-color: #2ba197;
    color: #fff;
    border-radius: 6px;
  }
  td.today {
    font-weight: 700 !important;
    background: #eeeeee !important;
  }
  .daterangepicker .calendar-table td {
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
    min-width: 32px;
    width: 32px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    border-radius: 30px;
    border: 1px solid transparent;
    cursor: pointer;
  }
  .daterangepicker .ranges li.active {
    background-color: #fff;
    color: #2ba197;
    font-weight: 700;
  }
}
// ------------End Css date Range picker ----------------------//
</style>
